import * as React from 'react';
import moment from 'moment-timezone';
import { useLocation } from 'react-router-dom';
import { Angebotsuebersicht } from './Angebotsuebersicht';
import { AngebotsuebersichtList } from './AngebotsuebersichtList';

export const AngebotsuebersichtPrint: React.FC = () => {
    const location = useLocation();
    const urlSearchParams = new URLSearchParams(location.search);

    const statusList = (urlSearchParams.get('statusList') || '')
        .split(',')
        .map((s) => parseInt(s, 10))
        .filter((n) => !Number.isNaN(n));

    const datumVon = urlSearchParams.get('datumVon') || moment().format('YYYY-MM-DD');
    const datumBis = urlSearchParams.get('datumBis') || moment().format('YYYY-MM-DD');

    const kNr = urlSearchParams.get('kNr') ? parseInt(urlSearchParams.get('kNr') || '0', 10) : undefined;
    const konzernNr = urlSearchParams.get('konzernNr')
        ? parseInt(urlSearchParams.get('konzernNr') || '0', 10)
        : undefined;
    const kName = urlSearchParams.get('kName') || undefined;
    const konzernName = urlSearchParams.get('konzernName') || undefined;

    const kundePlzVon = urlSearchParams.get('kundePlzVon')?.trim() || undefined;
    const kundePlzBis = urlSearchParams.get('kundePlzBis')?.trim() || undefined;
    const kundeUmsatzTsdVon = urlSearchParams.get('kundeUmsatzTsdVon')
        ? parseInt(urlSearchParams.get('kundeUmsatzTsdVon') || '0', 10)
        : 0;
    const kundeUmsatzTsdBis = urlSearchParams.get('kundeUmsatzTsdBis')
        ? parseInt(urlSearchParams.get('kundeUmsatzTsdBis') || '0', 10)
        : 0;

    const kundeBranchen = (urlSearchParams.get('kundeBranchen') || '')
        .split(',')
        .map((s) => parseInt(s, 10))
        .filter((n) => !!n);
    const kundeErweiterteSuchen = (urlSearchParams.get('kundeErweiterteSuchen') || '')
        .split(',')
        .map((s) => parseInt(s, 10))
        .filter((n) => !!n);
    const kundeInteresseFuerProdukte = (urlSearchParams.get('kundeInteresseFuerProdukte') || '')
        .split(',')
        .map((s) => parseInt(s, 10))
        .filter((n) => !!n);

    const kundeBetreuer = urlSearchParams.get('kundeBetreuer')
        ? parseInt(urlSearchParams.get('kundeBetreuer') || '0', 10)
        : undefined;
    const kundeTelBetreuer = urlSearchParams.get('kundeTelBetreuer')
        ? parseInt(urlSearchParams.get('kundeTelBetreuer') || '0', 10)
        : undefined;

    const betreuer = urlSearchParams.get('betreuer') ? parseInt(urlSearchParams.get('betreuer') || '0', 10) : undefined;
    const betreuerGebiet = urlSearchParams.get('betreuerGebiet') === 'true';
    const telBetreuer = urlSearchParams.get('telBetreuer')
        ? parseInt(urlSearchParams.get('telBetreuer') || '0', 10)
        : undefined;

    const artikelGruppeNr = urlSearchParams.get('artikelGruppeNr')
        ? parseInt(urlSearchParams.get('artikelGruppeNr') || '0', 10)
        : undefined;

    const produktgruppen = (urlSearchParams.get('produktgruppen') || '')
        .split(',')
        .map((s) => parseInt(s, 10))
        .filter((n) => !!n);
    const telBetreuerGebiet = urlSearchParams.get('telBetreuerGebiet') === 'true';
    const showBetreuer = urlSearchParams.get('showBetreuer') === 'true';
    const showTelBetreuer = urlSearchParams.get('showTelBetreuer') === 'true';
    const showDetails = urlSearchParams.get('showDetails') === 'true';
    const previousYear1 = urlSearchParams.get('previousYear1') === 'true';
    const previousYear2 = urlSearchParams.get('previousYear2') === 'true';
    const previousYear3 = urlSearchParams.get('previousYear3') === 'true';

    return showDetails ? (
        <AngebotsuebersichtList
            statusList={statusList}
            datumVon={datumVon}
            datumBis={datumBis}
            kNr={kNr}
            kName={kName}
            konzernNr={konzernNr}
            konzernName={konzernName}
            kundePlzVon={kundePlzVon}
            kundePlzBis={kundePlzBis}
            kundeUmsatzTsdVon={kundeUmsatzTsdVon}
            kundeUmsatzTsdBis={kundeUmsatzTsdBis}
            kundeBranchen={kundeBranchen}
            kundeErweiterteSuchen={kundeErweiterteSuchen}
            kundeInteresseFuerProdukte={kundeInteresseFuerProdukte}
            kundeBetreuer={kundeBetreuer}
            kundeTelBetreuer={kundeTelBetreuer}
            betreuer={betreuer}
            showBetreuer={showBetreuer}
            showTelBetreuer={showTelBetreuer}
            betreuerGebiet={betreuerGebiet}
            telBetreuer={telBetreuer}
            telBetreuerGebiet={telBetreuerGebiet}
            artikelGruppeNr={artikelGruppeNr}
            produktgruppen={produktgruppen}
            showDetails={showDetails}
            previousYear1={previousYear1}
            previousYear2={previousYear2}
            previousYear3={previousYear2}
            printView
        />
    ) : (
        <Angebotsuebersicht
            statusList={statusList}
            datumVon={datumVon}
            datumBis={datumBis}
            kNr={kNr}
            kName={kName}
            konzernNr={konzernNr}
            konzernName={konzernName}
            kundePlzVon={kundePlzVon}
            kundePlzBis={kundePlzBis}
            kundeUmsatzTsdVon={kundeUmsatzTsdVon}
            kundeUmsatzTsdBis={kundeUmsatzTsdBis}
            kundeBranchen={kundeBranchen}
            kundeErweiterteSuchen={kundeErweiterteSuchen}
            kundeInteresseFuerProdukte={kundeInteresseFuerProdukte}
            kundeBetreuer={kundeBetreuer}
            kundeTelBetreuer={kundeTelBetreuer}
            betreuer={betreuer}
            showBetreuer={showBetreuer}
            showTelBetreuer={showTelBetreuer}
            betreuerGebiet={betreuerGebiet}
            telBetreuer={telBetreuer}
            telBetreuerGebiet={telBetreuerGebiet}
            produktgruppen={produktgruppen}
            showDetails={showDetails}
            previousYear1={previousYear1}
            previousYear2={previousYear2}
            previousYear3={previousYear3}
            printView
        />
    );
};
